export default {
	name: 'Convention.Checkout.Wins',
	path: 'convention/checkout/wins',
	meta: {
		auth: false
	}
}